export type ListTabId = 'favorite' | 'ban';
export type AddFormKind = 'favorite' | 'ban';
export type ClientPreferenceType = 'favorite_price_list' | 'banned_price_list';
export type ClientPreference = {
    id: string;
    type: ClientPreferenceType;
    value: string;
    comment: string;
    client: string;
};

export const getPreferenceTypeByFormKind = (kind: AddFormKind): ClientPreferenceType =>
    kind === 'favorite' ? 'favorite_price_list' : 'banned_price_list';

export const getAddFormKindByType = (type: ClientPreferenceType): AddFormKind =>
    type === 'favorite_price_list' ? 'favorite' : 'ban';